import {
  TextInput,
  TextInputProps,
  useListContext,
  useRedirect,
} from 'react-admin';
import { UUID_REGEX } from '../../utils/regex';

export const IDSearch: React.FC<TextInputProps> = (props) => {
  const redirect = useRedirect();
  const { resource } = useListContext();

  // Capture phase, so a pasted ID never reaches the filter form. Otherwise its
  // debounced submit is flushed when the list unmounts and navigates back.
  const handleChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (UUID_REGEX.test(value)) {
      e.stopPropagation();
      redirect(`/${resource}/${value}/show`);
    }
  };

  return <TextInput onChangeCapture={handleChangeCapture} {...props} />;
};
